export const MPK_BUSINESS_TIP = 'mpkBusinessTip';

export const MPK_BUSINESS_TIP_ACTIONS_NAME = {
  fetchParticipantsList: `${MPK_BUSINESS_TIP}/fetchParticipantsList`, // Получение Председателей РФ ДС
  fetchForeignParticipantsList: `${MPK_BUSINESS_TIP}/fetchForeignParticipantsList`, // Получение Председателей Иностранной части ДС
} as const;

export const MPK_BUSINESS_TIP_MUTATIONS_NAME = {
  setParticipantsList: `setParticipantsList`,
  setForeignParticipantsList: `setForeignParticipantsList`,
} as const;

export const MPK_BUSINESS_TIP_GETTERS_NAME = {
  getParticipantsList: `${MPK_BUSINESS_TIP}/getParticipantsList`,
  getForeignParticipantsList: `${MPK_BUSINESS_TIP}/getForeignParticipantsList`,
} as const;
